import AddValveChackDetail from "../components/configuration/chackValveDetail/AddChackValveDetail";
const AddChackValveDetailPage = () =>{
    return(
        <AddValveChackDetail/>
    )
}

export default AddChackValveDetailPage;